import { render, staticRenderFns } from "./BookingViewPdfs.vue?vue&type=template&id=4f36474f&scoped=true&"
import script from "./BookingViewPdfs.vue?vue&type=script&lang=js&"
export * from "./BookingViewPdfs.vue?vue&type=script&lang=js&"
import style0 from "./BookingViewPdfs.vue?vue&type=style&index=0&id=4f36474f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36474f",
  null
  
)

export default component.exports